import { BindAll } from 'lodash-decorators'
import { MySettingsNoticeController } from './settings-notice'

@BindAll()
export class MySettingsController {
  Notice = new MySettingsNoticeController()
}
